import * as angular from 'angular';
import * as _ from 'lodash';
import { Plant } from "../../models/navigation";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import BatchSummaryServiceName, { BatchSummaryService } from "../../services/batches/batchSummary.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NewGuidServiceName, { NewGuidService } from "../../services/utility/newguid.service";
import { apsCommands } from "../../shared/dto/aps.commands";
import { apsCommon } from "../../shared/dto/aps.common";
import template from './addBatchSummary.tpl.html';
import { any } from '@uirouter/angularjs';

let requires = [BatchSummaryServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName];

interface AddBatchSummaryController {
  add(): void;
  cancel(): void;
  setBatchRow: boolean;
}

export interface AddBatchSummaryParams {
  plant: Plant;
  tank: apsCommon.IdAndName;
  productionDate: Date;
  batchSummaryInfo: apsViewModels.BatchSummaryItem[];
}

export function openAddBatchSummary(data: AddBatchSummaryParams,
  $modal: mm.foundation.modal): angular.IPromise<apsViewModels.BatchSummaryItem[]> {
  return $modal.open({
    template: template,
    controller: 'AddBatchSummaryCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class AddBatchSummaryCtrl implements AddBatchSummaryController {
  instance: apsViewModels.BatchSummaryItem;
  form: angular.IFormController;
  batchSummaryInfo: apsViewModels.BatchSummaryItem[];
  plant: Plant;
  tank: apsCommon.IdAndName;
  setBatchRow: boolean;  
  
  private batchSummaryService: BatchSummaryService;
  private $modalInstance: mm.foundation.modalInstance;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  private newGuidService: NewGuidService;

  constructor(
    data: AddBatchSummaryParams,
    newGuidService: NewGuidService,
    batchSummaryService: BatchSummaryService,
    $modalInstance: mm.foundation.modalInstance,
    notifyService: NotifyService,
    loaderService: LoaderService
  ) {
    this.batchSummaryService = batchSummaryService;
    this.$modalInstance = $modalInstance;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.newGuidService = newGuidService;

    this.plant = data.plant;
    this.tank = data.tank;
    this.batchSummaryInfo = data.batchSummaryInfo;
    this.setBatchRow = this.batchSummaryInfo.filter(x => x.binName.toLowerCase() == 'batch')[0] !== undefined ? true : false;
    
  }

  checkRecordExist(): boolean{
    var batchRecords =  this.batchSummaryInfo.filter(x => x.binName.toLowerCase() != 'batch');
    return batchRecords.length > 0;
  }

  
  add(): void {
    if (this.form.$invalid) {
      return;
    }

    if (this.batchSummaryInfo.length == 1 && this.batchSummaryInfo[0].id) {
      let command = <apsCommands.BatchSummaryItem>this.batchSummaryInfo.map(bi => bi as apsCommands.BatchSummaryItem)[0];
      this.loaderService.loadingPromise(this.batchSummaryService.update(command, this.tank.id)
        .then((summary) => {
          this.$modalInstance.close([summary]);
        }, this.notifyService.handleApiErrors)
      );
    }
    else {
      let command = <apsCommands.BatchSummaryItem[]>this.batchSummaryInfo.map(bi => bi as apsCommands.BatchSummaryItem);
      this.loaderService.loadingPromise(this.batchSummaryService.add(command, this.tank.id)
        .then((summary) => {
          this.$modalInstance.close(summary);
        }, this.notifyService.handleApiErrors)
      );
    }
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.addBatchSummary', requires)
  .controller('AddBatchSummaryCtrl', AddBatchSummaryCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/addBatchSummary.controller.ts